export default "__VITE_ASSET__BVTrpFC2__"